import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import Button from "../Button";

type Props = {
	onContinue: () => void;
};

export const VerificationSuccessView = ({ onContinue }: Props) => {
	const { t } = useTranslation();
	const theme = useAppTheme();

	return (
		<Box
			id="verify-success-view"
			justifyContent="center"
			alignItems="center"
			gap={24}
			flex={1}
		>
			<Icon
				name="check-circle-outline"
				size={120}
				color={theme.colors.primary}
			/>
			<Box gap={8} alignItems="center">
				<Text variant="titleLarge" style={{ textAlign: "center" }}>
					{t("auth.verify.successTitle")}
				</Text>
				<Text variant="bodyLarge" style={{ textAlign: "center" }}>
					{t("auth.verify.successBody")}
				</Text>
			</Box>
			<Button
				testID="verify-success-continue-button"
				mode="contained"
				onPress={onContinue}
			>
				{t("auth.verify.successCtaLabel")}
			</Button>
		</Box>
	);
};
